import { render } from "./SizeStat.vue?vue&type=template&id=1176b21e"
import script from "./SizeStat.vue?vue&type=script&lang=js"
export * from "./SizeStat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__